import { Center } from 'component/base/Grid';
import React from 'react';

import SpiralLoading, { IProps } from './SpiralLoading';

const ContentLoading = (props: IProps) => (
  <Center>
    <SpiralLoading {...props} />
  </Center>
);

export default ContentLoading;
